import { useEffect } from "react";
import bridge from "../turbo/bridge";

export const DEVICE_REGISTRATION_REFRESHED_FLAG =
  "tixxt:deviceRegistrationRefreshed";
export const DEVICE_REGISTRATION_REFRESH_DELAY_MS = 5000;

/**
 * Refresh the device registration once per app start: FCM tokens rotate
 * (reinstall, backup restore, expiry) but the apps only register on a fresh
 * login — stale tokens let pushes die silently (tixxt-turbo-apps#216). The
 * native handler answers with a plain re-POST of the current token; user
 * notification settings are untouched (the endpoint never writes settings).
 */
export default function useDeviceRegistrationRefresh(
  currentMember: (typeof Preload)["current_member"] | null,
) {
  useEffect(() => {
    if (!window.isApp || currentMember == null) return;
    if (window.location.pathname === "/legal") return;
    if (sessionStorage.getItem(DEVICE_REGISTRATION_REFRESHED_FLAG)) return;

    // Delayed so older iOS builds have their cached FCM token ready before
    // they force-unwrap it. No cleanup, and the guard is only set once the
    // trigger actually fired: App remounts on every FULL page load (legacy
    // pages, non-Turbo forms — Turbo visits keep the permanent #app-root),
    // and a full load within the delay kills the timer — setting the flag
    // early would then swallow the refresh for the whole webview session.
    setTimeout(() => {
      sessionStorage.setItem(DEVICE_REGISTRATION_REFRESHED_FLAG, "1");
      bridge.askToRegisterDevice();
    }, DEVICE_REGISTRATION_REFRESH_DELAY_MS);
  }, [currentMember]);
}
